module.exports = __webpack_public_path__ + "img/conny-f-stage6-blink.3b83dc81.png";